import { Heading, LiliButton, FontWeight, Text } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { useBlocker } from '@tanstack/react-router';
import LiliLogo from '@Assets/logos/lili-logo-blue.svg';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { EnvironmentVariables, getEnvironmentVariable } from '@Services/env/environment.service';

export const AccountantPortalComplete = () => {
  const { t } = useTranslation('inviteTeamMember');

  const handleGoToPortal = () => {
    const redirectUrl = getEnvironmentVariable(EnvironmentVariables.VITE_APP_DEEPLINK);
    window.location.href = redirectUrl;
  };

  useBlocker({
    shouldBlockFn: ({ next }) => {
      if (next.routeId === routesModel[RoutesMap.SET_PASSWORD].path) {
        return true;
      }
      return false;
    },
    enableBeforeUnload: false,
  });

  return (
    <div className='bg-surface-primary-bw-03 flex items-center justify-center w-full min-h-screen'>
      <div className='bg-surface-primary-bw-00 flex flex-col items-center gap-[56px] p-[32px] rounded-[20px] w-[564px]'>
        <img src={LiliLogo} alt='Lili Logo' className='w-[64px] h-[58.667px]' />

        <div className='flex flex-col items-center gap-[12px] text-center w-full'>
          <Heading.H4 fontWeight={FontWeight.SEMIBOLD} className='tracking-[-0.8px]'>
            {t('accountantPortalComplete.title')}
          </Heading.H4>

          <Text.H9 className='text-text-main-primary tracking-[-0.2px]'>
            {t('accountantPortalComplete.subtitle')}
          </Text.H9>
        </div>

        <LiliButton
          id='go-to-portal-button'
          title={t('accountantPortalComplete.goToPortal')}
          onClick={handleGoToPortal}
          className='!w-auto h-[44px] px-[40px] py-[14px]'
        />
      </div>
    </div>
  );
};

export default AccountantPortalComplete;
